/**
 * TestCaseList component displays  list of test cases for a submission.
 * It shows the student's name, email, and obtained marks.
 * The test case results are displayed in a table with a row click functionality
 * to select a specific test case. The component highlights the row based on
 * the test case status (pass/fail).
 */

import React, { useEffect } from "react";
import "./TestCaseList.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { GiCrossMark } from "react-icons/gi";
import { TiTick } from "react-icons/ti";
import TableComponent from "./TableComponent";

const TestCaseList = ({
  testcaseResults, // Array of test case results
  selectedTestcase, // Currently selected test case
  setSelectedTestcase, // Function to set the selected test case
  studentName, // Student's name
  studentEmail, // Student's email
  obtainedMarks, // Marks obtained by the student
  testcaseType, // Type of test case (visible or hidden)
}) => {
  // Effect to set the initially selected test case when the component mounts
  useEffect(() => {
    if (Array.isArray(testcaseResults) && testcaseResults.length > 0) {
      setSelectedTestcase(testcaseResults[0]);
    }
  }, [testcaseResults, setSelectedTestcase]);

  // Handles row click event to select a test case.
  const onRowClick = (e) => {
    // Check if the clicked row is already selected
    if (
      selectedTestcase &&
      selectedTestcase.testcase_id === e.data.testcase_id
    ) {
      // If it is, do nothing
      return;
    }
    // If it's not, update the state to select the new row
    setSelectedTestcase(e.data);
  };

  // Determines the CSS class for a row based on the test case status.

  const rowClass = (data) => {
    return {
      "pass-status": data.testcase_status === "pass",
      "fail-status": data.testcase_status === "fail",
    };
  };

  //  Custom body template for the status column.

  const statusTemplate = (rowData) => {
    if (rowData.testcase_status === "fail") {
      return <GiCrossMark color="red" />;
    } else {
      return <TiTick color="green" />;
    }
  };

  // Define the columns for the table
  const columns = [
    { field: "testcase_status", header: "Status", body: statusTemplate },
    { field: "testcase_name", header: "Name" },
    { field: "marks_obtained", header: "Marks" },
  ];

  return (
    <div>
      <div>
        <strong>Name:</strong> {studentName} <br />
        <strong>Email:</strong> {studentEmail} <br />
        <strong>
          {testcaseType === "visible_testcases"
            ? "Practice Marks: "
            : "Evaluate Marks: "}
        </strong>
        {obtainedMarks} <br />
      </div>

      <hr
        style={{
          height: "1px",
          border: "none",
          backgroundColor: "#d2d2d2",
        }}
      />
      <TableComponent
        tableData={testcaseResults} // Data for the table
        scrollable={false} // Disable scrolling
        selectionMode={"single"} // Single row selection
        onRowClick={onRowClick} // Row click handler
        selectedRowData={selectedTestcase} // Currently selected row data
        metaKeySelection={false} // Disable meta key selection
        rowClassName={rowClass} // Function to determine row class
        columns={columns} // Columns definition
      />
    </div>
  );
};

export default TestCaseList;
